import { render } from "./resellers.vue?vue&type=template&id=bdbe24e6&scoped=true"
import script from "./resellers.vue?vue&type=script&lang=js"
export * from "./resellers.vue?vue&type=script&lang=js"

import "./resellers.vue?vue&type=style&index=0&id=bdbe24e6&lang=css"
import "./resellers.vue?vue&type=style&index=1&id=bdbe24e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbe24e6"]])

export default __exports__